var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCardMastercard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 52,
    viewBox: "0 0 72 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1011_27300)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 10C12 7.79086 13.7909 6 16 6H56C58.2091 6 60 7.79086 60 10V30C60 32.2091 58.2091 34 56 34H16C13.7909 34 12 32.2091 12 30V10Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9062 14.5342H32.5605V25.8139H38.9062V14.5342Z",
    fill: "#FF5F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9635 20.1742C32.9617 17.9734 33.9831 15.8941 35.7334 14.5353C32.76 12.224 28.49 12.5607 25.9243 15.3087C23.3586 18.0568 23.3586 22.2936 25.9243 25.0416C28.49 27.7897 32.76 28.1263 35.7334 25.815C33.9826 24.4558 32.9611 22.3756 32.9635 20.1742Z",
    fill: "#EB001B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4689 20.175C47.4688 22.9214 45.8833 25.4266 43.3858 26.6268C40.8883 27.8269 37.9172 27.5113 35.7344 25.8138C37.4839 24.4539 38.5054 22.3749 38.5054 20.174C38.5054 17.9731 37.4839 15.8941 35.7344 14.5341C37.9172 12.8367 40.8883 12.5211 43.3858 13.7212C45.8833 14.9214 47.4688 17.4266 47.4689 20.173V20.175Z",
    fill: "#F79E1B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1011_27300",
    x: 0,
    y: 0,
    width: 72,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.160784 0 0 0 0 0.168627 0 0 0 0 0.196078 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1011_27300"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1011_27300",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardMastercard);
export default __webpack_public_path__ + "static/media/card-mastercard.9e0d8285b20451f4c34946deaac1cfb9.svg";
export { ForwardRef as ReactComponent };